// extracted by mini-css-extract-plugin
export default {"container":"BaseHeader_container__qFShG","labelContainer":"BaseHeader_labelContainer__QD5R4","filterIcon":"BaseHeader_filterIcon__P5-m7"};